export const findLatestValue = (values: readonly number[]) => {
  for (let i = values.length - 1; i >= 0; i -= 1) {
    if (values[i] !== 0 && values[i] !== null && values[i] !== undefined) {
      return { index: i, value: values[i] };
    }
  }
  return { index: -1, value: null };
};

export const sumArray = (values: readonly number[]) =>
  values.reduce((total, current) => total + (current ?? 0), 0);

export const formatNumber = (value: number | null, fractionDigits = 0) => {
  if (value === null || Number.isNaN(value)) {
    return '-';
  }
  return value.toLocaleString('tr-TR', {
    maximumFractionDigits: fractionDigits,
    minimumFractionDigits: fractionDigits
  });
};

